module.exports = __webpack_public_path__ + "static/media/Map2.4c8e037c.jpg";